import { LeadOnlyForm } from './style-data';

export const jwtToken = {};

// Snapshot of jwtToken's fields as of the last resetJwtToken() call. Terminal pages (follow-up,
// already-scheduled) reset jwtToken as soon as they mount so a later Back-button remount of the
// entry form can't reuse this session's token — but those same terminal pages may still read
// jwtToken directly for their own rendering (e.g. AlreadyScheduled shows jwtToken.data). Components
// that do so should fall back to jwtTokenLast so a stray re-render after the reset doesn't blank
// out what's on screen.
export const jwtTokenLast = {};

// Wipes every field on the shared singleton in place (can't reassign the export binding, so we
// delete each own key instead) so the next entry-form mount sees an unauthenticated jwtToken and
// is forced through a fresh oneTimeAuth handshake rather than reusing this session's token.
export const resetJwtToken = () => {
  Object.keys(jwtTokenLast).forEach((key) => delete jwtTokenLast[key]);
  Object.assign(jwtTokenLast, jwtToken);
  Object.keys(jwtToken).forEach((key) => delete jwtToken[key]);
};

export const HasLeadOrSlots = () => {
  const data = jwtToken.data;
  const slots = data?.slots || jwtToken.slots;
  return jwtToken.leadStatusLead || !!slots;
};

export const skipScheduleSlotPage = () => {
  return (LeadOnlyForm() && !jwtToken.existingLeadReturned) || jwtToken.leadSaveOnly || !HasLeadOrSlots();
};
